/**
 * BookableResourceImageService
 * Service for managing bookable resource images
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for bookable resource image CRUD operations with resource-specific queries
 */
export class BookableResourceImageService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BookableResourceImageService.DEFAULT_SERVICE_PATH,
            basePath: BookableResourceImageService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET BY RESOURCE ====================
    /**
     * Get all images for a specific bookable resource
     * @param resourceId - The bookable resource ID
     * @returns Array of bookable resource images
     */
    async getByResource(resourceId) {
        const response = await this.getByResourceRaw(resourceId);
        return response.data ?? [];
    }
    /**
     * Get all images for a specific bookable resource with full response
     * @param resourceId - The bookable resource ID
     * @returns ResponseData with array of bookable resource images
     */
    getByResourceRaw(resourceId) {
        const url = this.buildUrl(`by-resource/${resourceId}`);
        return this.http.get(url);
    }
}
BookableResourceImageService.DEFAULT_SERVICE_PATH = 'booking-management';
BookableResourceImageService.BASE_PATH = 'api/bookable-resource-images';
//# sourceMappingURL=BookableResourceImageService.js.map